
export default {
  props: {
    offer: {
      type: Object,
      required: true,
    },
    isLarge: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      shareActive: false,
    };
  },
  computed: {
    imageSrc () {
      return this.$store.state.config.default_page_image.sizes[`2048x2048`];
    },
    imageSrcset () {
      return this.$store.state.config.default_page_image.sizes[`1078x1078`];
    },
    imageTitle () {
      return this.$store.state.config.default_page_image.title;
    },
    excerptLength () {
      return this.$store.state.config.excerpt_lengths.news_card;
    },
    socialShareDetails () {
      return {
        link: this.offer.offer_link,
        title: this.offer.offer_title,
      };
    },
  },
};
